import * as CONSTS from './common/const/service-worker-constants';
import {isQAModeEnabled} from './utils/qa-mode-utils';

window['orbitServiceWorkerStarter'] = () => {
    try {
        // CAUTION: this function is declared early but should be called after we have window.$allConfigs or if we run in QA mode!!!
        console.debug('Executing Orbit service worker starter');

        const isQAEnv = isQAModeEnabled();
        const allConfigs: any = window[CONSTS.ALL_CONFIGS_KEY] ? window[CONSTS.ALL_CONFIGS_KEY] : {};
        const isPWAEnabled = isQAEnv || allConfigs?.orbit?.extraProperties?.pwaEnabled? true : false;


        const getSwParams = function() {
            const params: any = {
                isQAEnv: isQAEnv,
                pwaEnabled: isPWAEnabled
            };

            const webPushSettings = Object.assign({}, allConfigs?.sdk?.config?.WebPush, allConfigs?.orbit?.config?.SDK?.WebPush);
            if (webPushSettings) {
                const airshipSettings = isQAEnv ?
                    (webPushSettings.testSettings ? webPushSettings.testSettings : CONSTS.QA_ENV_URBAN_DEFAULT_SETTINGS) :
                    (webPushSettings.enabled ? webPushSettings.prodSettings : null);

                if (airshipSettings) {
                    params.airshipSettings = airshipSettings;
                }
            }

            return params;
        }

        const getSwUrl = function() {
            const params = getSwParams();
            let swBaseUrl = "/service-worker.js?";
            const paramsQueryString = `params=${encodeURIComponent(JSON.stringify(params))}`;
            if (allConfigs?.orbit?.extraProperties?.paths?.serviceWorkerBase) {
                swBaseUrl = allConfigs.orbit.extraProperties.paths.serviceWorkerBase;
                return swBaseUrl + "&" + paramsQueryString;
            }
            return swBaseUrl + paramsQueryString;
        }

        const savePwaPrompt = function () {
            window.addEventListener('beforeinstallprompt', function(e) {
                console.info("PWA beforeinstallprompt handler called");
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault();
                if (window[CONSTS.PWA_PROMPT_CALLBACK]) {
                    // if we have a callback set, call it
                    window[CONSTS.PWA_PROMPT_CALLBACK](e);
                } else {
                    // stash the event so it can be triggered later
                    window[CONSTS.PWA_PROMPT_EVENT] = e;
                }
            });

            window.addEventListener('appinstalled', function(e) {
                console.info("PWA appinstalled handler called");
                if (window[CONSTS.PWA_INSTALLED_CALLBACK]) {
                    // if we have a callback set, call it
                    window[CONSTS.PWA_INSTALLED_CALLBACK](e);
                }
            });
        }

        const getSwRegistrationState = function(swRegistration: ServiceWorkerRegistration) {
            const state: ServiceWorker = swRegistration.installing || swRegistration.waiting || swRegistration.active;
            return state;
        }

        const registerServiceWorker = function () {
            if ('serviceWorker' in navigator) {

                const swUrl = getSwUrl();
                navigator.serviceWorker
                    .register(swUrl)
                    .then(function (swRegistration) {
                        const swState = getSwRegistrationState(swRegistration);
                        if (swState) {
                            swState.addEventListener("statechange", (e: any) => {
                                console.debug('Service Worker state changed', e.target.state );
                            });
                        }
                        console.info('Service Worker Registered', swRegistration, swState);
                    })
                    .catch(function (err) {
                        console.error('Service Worker failed to register', err);
                    });
            } else {
                console.error('Service Worker error - navigator.serviceWorker object does not exist!');
            }
        }

        const addPwaManifest = function() {
            var linkTag = document.querySelector('link#manifest-placeholder') as HTMLLinkElement;
            const pwaPath = allConfigs?.orbit?.extraProperties?.paths?.pwaResources;
            if (linkTag && pwaPath) {
                linkTag.href = pwaPath + '/manifest.json';
            }
        }

        ////
        //main code
        ////

        //1. set helper function to get service worker url
        window['getOrbitServiceWorkerUrl'] = function() {
            return getSwUrl();
        }

        //2. if pwa is enabled, run specific code
        console.info(`PWA isEnabled: ${isPWAEnabled}`);
        if (isPWAEnabled) {
            savePwaPrompt();
            addPwaManifest();
        }

        registerServiceWorker();
    } catch (err) {
        console.error('Error in Orbit service worker starter', err);
    }
}
